const DIGITAL_HOME_PHONE = 'Digital Home Phone';

export { DIGITAL_HOME_PHONE };
